import { Fragment } from 'react';
import { Skeleton } from '@/components/ui/skeleton';

// Loading placeholder for the channel-detail body, shared by both the WhatsApp
// and Instagram variants. Shown while the on-mount detail + refresh fetch is in
// flight so the body never flashes "N/A" → real value (Meta Business Portfolio)
// or shifts layout when the Phone Number ID row appears. Width pairs give the
// grid a natural, non-uniform rhythm; keyed by id to avoid array-index keys.
const ROWS = [
  { id: 'r1', label: 'w-36', value: 'w-24' },
  { id: 'r2', label: 'w-28', value: 'w-56' },
  { id: 'r3', label: 'w-24', value: 'w-32' },
  { id: 'r4', label: 'w-32', value: 'w-48' },
  { id: 'r5', label: 'w-40', value: 'w-40' },
  { id: 'r6', label: 'w-28', value: 'w-52' },
  { id: 'r7', label: 'w-32', value: 'w-36' },
];

export function ChannelBodySkeleton() {
  return (
    <div
      role="status"
      aria-label="Loading channel details"
      className="mt-2 grid grid-cols-1 md:grid-cols-[200px_1fr] gap-x-10 gap-y-4 text-sm"
    >
      {ROWS.map((row) => (
        <Fragment key={row.id}>
          <Skeleton className={`h-4 ${row.label}`} />
          <Skeleton className={`h-4 ${row.value}`} />
        </Fragment>
      ))}
    </div>
  );
}
